import styled from "styled-components";
import { COLORS } from "../../../../../../../assets/constants/styles";

export const RelevantSectionsText = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.black};
  margin-bottom: 8px;
`;
